export enum ReviewSubjectAccessType {
    LEGACY = 'LEGACY',
    MANAGER_SUMMARY = 'MANAGER_SUMMARY',
    MANAGER_APPROVAL = 'MANAGER_APPROVAL',
    SUBJECT_ACCESS = 'SUBJECT_ACCESS'
}